import { render, staticRenderFns } from "./Shepherds.vue?vue&type=template&id=0f7c2a3c&scoped=true&"
import script from "./Shepherds.vue?vue&type=script&lang=js&"
export * from "./Shepherds.vue?vue&type=script&lang=js&"
import style0 from "./Shepherds.vue?vue&type=style&index=0&id=0f7c2a3c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7c2a3c",
  null
  
)

export default component.exports